import React from 'react';
import '../../scss/Staticview.scss';

export const Staticview = ({staticContent}) => (
	<table className="Staticview">
			<tbody>
					<tr>
						<td dangerouslySetInnerHTML={{__html: staticContent}}></td>
					</tr>
		</tbody>
	</table>
)



// WEBPACK FOOTER //
// ./src/components/Staticview/index.js